import { TRUST_SECTION, trustTopics } from './homepageContent';

/**
 * The Trust Center's place on the homepage since it moved into its own slide view (Ajay,
 * 2026-11-03): a slim strip just above the footer with the publishable trust statements (each
 * only while its evidence holds) and the two ways in — the Trust Center itself and Contact Us.
 * Both are plain links (#trust, /contact) that TrustCenterSlide turns into the slide view, like
 * every other link to them on the page.
 */

const FOCUS =
  'focus-visible:outline focus-visible:outline-2 focus-visible:outline-brass focus-visible:outline-offset-2';

export default function TrustStrip() {
  return (
    <section
      aria-labelledby="trust-strip-heading"
      className="border-t border-brass-hairline px-5 sm:px-8 lg:px-14 py-10"
    >
      <div className="flex flex-wrap items-center justify-between gap-x-8 gap-y-4">
        <h2 id="trust-strip-heading" className="font-display font-normal text-[26px] text-parchment">
          {TRUST_SECTION.heading}
        </h2>
        <div className="flex flex-wrap items-center gap-3">
          <a
            href="#trust"
            className={`border border-brass text-brass px-5 py-2.5 text-[12px] font-semibold tracking-[0.1em] uppercase hover:bg-brass hover:text-chamber-ink transition-colors ${FOCUS}`}
          >
            {TRUST_SECTION.open} →
          </a>
          <a
            href="/contact"
            className={`border border-chamber-border-hi text-chamber-muted px-5 py-2.5 text-[12px] font-semibold tracking-[0.1em] uppercase hover:border-brass hover:text-brass transition-colors ${FOCUS}`}
          >
            {TRUST_SECTION.contact}
          </a>
        </div>
      </div>
      <dl className="mt-6 grid gap-x-10 gap-y-5 sm:grid-cols-2 lg:grid-cols-4">
        {trustTopics().map((t) => (
          <div key={t.topic} className="border-l border-brass-hairline-soft pl-4">
            <dt className="font-plex text-[10.5px] font-medium tracking-[0.2em] uppercase text-brass">{t.topic}</dt>
            <dd className="mt-1.5 text-[13.5px] leading-[1.6] text-chamber-muted-bright">{t.statement}</dd>
          </div>
        ))}
      </dl>
    </section>
  );
}
